import * as React from 'react';
import * as styles from './styles.css';

import { Header0, Header2, InlineText1 } from '@cian/ui-kit/typography';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useDeviceType } from '@cian/ui-kit';

const bgImg = require('../../static/realtor_completed.png') as string;

export interface IQuizCompletedProps {
  backToPage: React.ReactElement;
  title: string;
  subtitle: string;
  footer?: React.ReactElement;
}

export const QuizCompleted: React.FC<IQuizCompletedProps> = props => {
  const { backToPage, title, subtitle, footer } = props;
  const deviceType = useDeviceType();

  return (
    <div className={styles['wrapper']} data-testid="success">
      <div className={styles['header']}>{backToPage}</div>
      <div className={styles['container']}>
        <div className={styles['title']}>
          <ConditionalWrapper if={deviceType === 'desktop'} ThenComponent={Header0} ElseComponent={Header2}>
            {title}
          </ConditionalWrapper>
        </div>
        <div className={styles['text']}>
          <InlineText1 color="current_color">{subtitle}</InlineText1>
        </div>
        {footer && (
          <div className={styles['footer']} data-testid="footer">
            {footer}
          </div>
        )}
        <img src={bgImg} className={styles['image']} />
      </div>
    </div>
  );
};

QuizCompleted.displayName = 'QuizCompleted';
